var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard --messages" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-8 col-xl-9" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "header d-flex align-items-center justify-content-between"
                        },
                        [
                          _c("h2", [_vm._v("Správy")]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "read-all",
                              on: {
                                click: function($event) {
                                  return _vm.setMessagesAsReaded(
                                    _vm.profil.pouzivatel_id.id
                                  )
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "icon" }),
                              _vm._v(
                                "Označiť všetky ako prečítané\n                        "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "accordion",
                          attrs: { id: "accordionExample" }
                        },
                        _vm._l(_vm.sortedMessages, function(message, index) {
                          return _c("div", { staticClass: "card" }, [
                            _c(
                              "div",
                              {
                                staticClass: "card-header",
                                on: {
                                  click: function($event) {
                                    _vm.collapseMessage(index)
                                    _vm.setMessageAsReaded(message.id, index)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "date" }, [
                                  _vm._v(
                                    _vm._s(
                                      message.created_at
                                        .replace(/-/g, ".")
                                        .replace(/:..$/g, "")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                !message.message_flag
                                  ? _c("a", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(message.message_title) +
                                          "\n                                "
                                      )
                                    ])
                                  : _c(
                                      "a",
                                      { staticStyle: { "font-weight": "300" } },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(message.message_title) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.collapse[index],
                                    expression: "collapse[index]"
                                  }
                                ],
                                staticClass: "collapse show"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    domProps: {
                                      innerHTML: _vm._s(message.message_sprava)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(message.message_sprava) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }